import { animate, query, stagger, style, transition, trigger } from '@angular/animations';
import { Component, ElementRef, Input, OnChanges, OnInit, ViewChild } from '@angular/core';
import Swiper from 'swiper';

@Component({
  selector: 'app-shops-slider',
  templateUrl: './shops-slider.component.html',
  styleUrls: ['./shops-slider.component.scss'],
  animations: [
    trigger('listStagger', [
      transition('* <=> *', [
        query(
          ':enter',
          [
            style({ opacity: 0, transform: 'translateY(-15px)' }),
            stagger('100ms', animate('550ms ease-out', style({ opacity: 1, transform: 'translateY(0px)' }))),
          ],
          { optional: true }
        ),
        query(':leave', animate('100ms', style({ opacity: 0 })), {
          optional: true,
        }),
      ]),
    ]),
  ],
})
export class ShopsSliderComponent implements OnInit, OnChanges {
  constructor() {}

  @ViewChild('shopsSlider') shopsSlider!: ElementRef | undefined;
  
  @Input() shops;

  @Input() floor;


  floorShops = [];

  shopsSliderConfig = {
    initialSlide: 0,
    slidesPerView: 6.5,
    slidesOffsetBefore: 20,
    slidesOffsetAfter: 20,
    spaceBetween: 15,
    autoplay: {
      delay: 4000,
    },
    loop: true,
    pagination: false,
    breakpoints: {
      0: {
        slidesPerView: 1.8,
        slidesOffsetBefore: 20,
        slidesOffsetAfter: 20,
      },

      767: {
        slidesPerView: 1.8,
        slidesOffsetBefore: 20,
        slidesOffsetAfter: 20,
      },
      768: {
        slidesPerView: 4.5,
        slidesOffsetBefore: 20,
        slidesOffsetAfter: 20,
      },

      919: {
        slidesPerView: 6.5,
      },
    },
  };

  

  slidePrev(): void {
    this.shopsSlider.nativeElement.swiper.slidePrev();
  }
  slideNext(): void {
    this.shopsSlider.nativeElement.swiper.slideNext();
  }

  ngOnInit() {
    this.floorShops = this.floor ? this.shops.filter((s) => s.floor === this.floor) : this.shops;
  }

  ngOnChanges() {
    this.floorShops = this.floor ? this.shops.filter((s) => s.floor === this.floor) : this.shops;
  }
}

